import '@/js/dist/www.iichi.com/common';

import { createApp, h } from 'vue';
import { uniq } from '@/js/lib/helper/array';
import { linkify } from '@/js/lib/helper/linkify';
import { pinia } from '@/js/lib/store';
import { useEventStore } from '@/js/lib/store/event';
import { useItemStore } from '@/js/lib/store/item';
import { addFollowButton, addFollowRecommend } from '@/js/lib/ui/follow-button';
import MessageButton from '@/js/components/listing/MessageButton.vue';
import EventLikeButtonSmall from '@/js/components/www.iichi.com/organisms/EventLikeButtonSmall.vue';
import LikeButtonSmall from '@/js/components/www.iichi.com/organisms/LikeButtonSmall.vue';
import ProfileSlider from '@/js/components/www.iichi.com/pages/people/ProfileSlider.vue';
import ListingSort from '@/js/components/www.iichi.com/pages/shop/ListingSort.vue';
import ShopInfoButton from '@/js/components/www.iichi.com/pages/shop/ShopInfoButton.vue';

document.addEventListener('DOMContentLoaded', () => {
  addFollowButton().then(addFollowRecommend);

  const messageButtonEl = document.querySelector('message-button') as HTMLElement;
  if (messageButtonEl) {
    createApp({
      render: () =>
        h(MessageButton, {
          shopId: Number(messageButtonEl.dataset.shopId),
          disabled: messageButtonEl.dataset.disabled === 'true',
        }),
    }).mount(messageButtonEl);
  }

  const tabEl = document.querySelector('.ui-tab') as HTMLElement;
  if (location.hash === '#tab') {
    tabEl.scrollIntoView({
      behavior: 'smooth',
    });
  }
  const tabLinkEls: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('a[href*="#tab"]');
  tabLinkEls.forEach((a) => {
    const { pathname, search } = new URL(a.href);
    if (pathname === window.location.pathname) {
      a.addEventListener('click', (event) => {
        const mySort = new URLSearchParams(window.location.search).get('sort');
        if (mySort === new URLSearchParams(search).get('sort')) {
          event.preventDefault();
          tabEl.scrollIntoView({
            behavior: 'smooth',
          });
        } else {
          window.location.href = a.href;
        }
      });
    }
  });

  const tabUlEl = document.querySelector('.ui-tab ul') as HTMLUListElement;
  const tabActiveEl = tabUlEl.querySelector('.active');
  if (tabActiveEl) {
    const { x } = tabActiveEl.getBoundingClientRect();
    tabUlEl.scrollTo({
      left: x - window.innerWidth / 2 + tabActiveEl.clientWidth / 2,
      behavior: 'smooth',
    });
  }

  const shopInfoButtonEl = document.querySelector('shop-info-button') as HTMLElement;
  if (shopInfoButtonEl) {
    createApp({
      render: () =>
        h(ShopInfoButton, {
          statementForNote: shopInfoButtonEl.dataset.statementForNote!,
          openingDate: shopInfoButtonEl.dataset.openingDate!,
        }),
    }).mount(shopInfoButtonEl);
  }

  const listingSortEl = document.querySelector('listing-sort') as HTMLElement;
  if (listingSortEl) {
    createApp({
      render: () =>
        h(ListingSort, {
          sort: listingSortEl.dataset.sort!,
        }),
    }).mount(listingSortEl);
  }

  const likeButtonEls: NodeListOf<HTMLElement> = document.querySelectorAll('like-button-small');
  if (likeButtonEls.length > 0) {
    const itemStore = useItemStore(pinia);
    const itemIds = Array.from(likeButtonEls, (el) => Number(el.dataset.itemId));
    itemStore.checkLiked(uniq(itemIds));
    likeButtonEls.forEach((el) => {
      createApp({
        render: () =>
          h(LikeButtonSmall, {
            itemId: Number(el.dataset.itemId),
          }),
      }).mount(el);
    });
  }

  const makerDescriptionEl = document.querySelector('.maker-description');
  if (makerDescriptionEl) {
    makerDescriptionEl.innerHTML = linkify(makerDescriptionEl.innerHTML);
  }

  const collectionDescriptionEl = document.querySelector('.collection-description');
  if (collectionDescriptionEl) {
    collectionDescriptionEl.innerHTML = linkify(collectionDescriptionEl.innerHTML);
  }

  const profileTextEl = document.querySelector('.about-me .text');
  if (profileTextEl) {
    profileTextEl.innerHTML = linkify(profileTextEl.innerHTML);
  }

  const sliderEl = document.querySelector('profile-slider') as HTMLElement;
  if (sliderEl) {
    createApp({
      render: () =>
        h(ProfileSlider, {
          slidesJson: sliderEl.dataset.slides!,
          imageWidth: Number(sliderEl.dataset.imageWidth),
          imageHeight: Number(sliderEl.dataset.imageHeight),
        }),
    }).mount(sliderEl);
  }

  const informationTextEl = document.querySelector('.informations');
  if (informationTextEl) {
    informationTextEl.innerHTML = linkify(informationTextEl.innerHTML);
  }

  const eventButtonEls: NodeListOf<HTMLElement> = document.querySelectorAll('event-like-button-small');
  if (eventButtonEls.length > 0) {
    const eventStore = useEventStore(pinia);
    const eventIds = Array.from(eventButtonEls, (el) => Number(el.dataset.eventId));
    eventStore.checkLiked(uniq(eventIds));
    eventButtonEls.forEach((el) => {
      createApp({
        render: () =>
          h(EventLikeButtonSmall, {
            eventId: Number(el.dataset.eventId),
          }),
      }).mount(el);
    });
  }
});
